import { isPlainObject } from 'trtc-js-sdk-core/src/utils/type-check.js';
import { TRTCStreamType, TRTCType } from './type';
import { RemoteStreamType, VideoContentHint, defaultBigVideoProfile, defaultSmallVideoProfile, videoProfileMap } from 'trtc-js-sdk-core';

export function convertStreamType<T extends RemoteStreamType | TRTCStreamType>(streamType: T):T extends RemoteStreamType ? TRTCStreamType : RemoteStreamType {
  if (streamType === TRTCStreamType.Sub) {
    // @ts-ignore
    return RemoteStreamType.Aux;
  }
  if (streamType === RemoteStreamType.Aux) {
    // @ts-ignore
    return TRTCStreamType.Sub;
  }
  // @ts-ignore
  return RemoteStreamType.Main;
}


export function getContentHintFromQosPreference(qosPreference?: typeof TRTCType.QOS_PREFERENCE_SMOOTH | typeof TRTCType.QOS_PREFERENCE_CLEAR) {
  if (qosPreference === TRTCType.QOS_PREFERENCE_CLEAR) return VideoContentHint.DETAIL;
  if (qosPreference === TRTCType.QOS_PREFERENCE_SMOOTH) return VideoContentHint.MOTION;
  return VideoContentHint.NONE;
}

export function convertVideoProfile(profile?: string | VideoProfile | boolean, isSmall?: boolean): VideoProfile {
  const defaultProfile = isSmall ? defaultSmallVideoProfile : defaultBigVideoProfile;
  // 先判断是否为对象类型，如果是对象则直接返回，需要补全默认值
  if (isPlainObject(profile)) {
    return { ...defaultProfile, ...profile };
  }
  // 判断是否为字符串键值
  if (videoProfileMap[profile as keyof typeof videoProfileMap]) {
    return videoProfileMap[profile as keyof typeof videoProfileMap];
  }

  // 返回默认值
  return defaultProfile;
}
